import { C as CosmosMode$1, d as defineCustomElement$1 } from './p-DZLtnVbO.js';

const CosmosMode = CosmosMode$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosMode, defineCustomElement };
